import { CdkColumnDef, CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { LsqTablesModule } from '@lsq-frontend/common-ui';
import { AppCommonModule } from '../app-common.module';
import { factoringAtlas } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { IncreaseCreditLimitComponent } from './increase-credit-limit.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: UiRoutes.Home,
                component: IncreaseCreditLimitComponent,
                data: {
                    title: factoringAtlas.INCREASE_CREDIT_LIMIT.title
                }
            }
        ]),
        AppCommonModule,
        CdkTableModule,
        LsqTablesModule.forChild()
    ],
    declarations: [IncreaseCreditLimitComponent],
    providers: [CdkColumnDef]
})
export class IncreaseCreditLimitModule {}
